import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70855228"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "get-the-look__product q-position-relative q-row" }
const _hoisted_2 = { class: "accesories_left-container q-position-absolute q-d-flex q-col-4 q-px-0" }
const _hoisted_3 = { class: "container q-d-flex q-col-4 q-px-0" }
const _hoisted_4 = { class: "accesories_right-container q-position-absolute q-d-flex q-col-4 q-px-0" }

import {generateStaticImage, formatPrice, getDiscount, parsePrice} from '@/core/utils'
import {ref, PropType} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CollagesComponent',
  props: {
  products: [],
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
},
  setup(__props) {

const props = __props;


// console.log('produkty w kolażu', props.products)
const getProductCategoriesByProductId = (products) => {
  return products.map((product) => {
    const firstVariant = product.variants[0]
    delete product.variants
    return {
      'productId': product.id,
      'productCategory': firstVariant.custom_label_1,
      'product': product
    }
  })
}

function findKeyByValue(object, value) {
  for (var key in object) {
    // eslint-disable-next-line no-prototype-builtins
    if (object.hasOwnProperty(key)) {
      if (object[key].indexOf(value) > -1) {
        return key;
      }
    }
  }
  return null;
}


const images = props.products.map((product) => {
  return generateStaticImage(product.image_link, 500, null)

})

const categoriesMapping = {
  "Shoe": [
    "Obuwie",
    "Baleriny",
    "Botki",
    "Mokasyny",
    "Obuwie domowe",
    "Japonki i klapki",
    "Półbuty",
    "Trampki i tenisówki",
    "Trapery",
    "Szpilki i czółenka",
    "Sneakersy",
    "Sandały",
    "Kozaki",
    "Koturny i espadryle",
    "Buty Baldinini",
    "Buty Liu Jo",
    "Buty Patrizia Pepe",
    "Buty Twinset"
  ],
  "Glasses": [
    "Okulary przeciwsłoneczne"
  ],
  "Pants": [
    "Jeansy",
    "Spodnie",
    "Spodnie i Legginsy",
    "Garnitury",
    "Spodnie Aeronautica Militare",
    "Spodnie Armani Exchange",
    "Spodnie Emporio Armani",
    "Spodnie Ice Play",
    "Spodnie Joop!",
    "Spodnie Joop! Jeans",
    "Spodnie Legginsy i Jegginsy Liu Jo"
  ],
  "Miniskirt": [
    "Spódnice"
  ],
  "Dress": [
    "Sukienki",
    "Sukienki Patrizia Pepe"
  ],
  "Glove": [
    "Rękawiczki"
  ],
  "Wallet": [
    "Portfele i saszetki"
  ],
  "Outerwear": [
    "Bluzki",
    "Bluzy",
    "Marynarki",
    "Marynarki i żakiety",
    "Płaszcze",
    "Ponczo",
    "Kurtki i płaszcze",
    "Kombinezony",
    "Garnitury",
    "Bluzy i Longsleeve Aeronautica Militare",
    "Bluzy i Longsleeve Armani Exchange",
    "Bluzy i Longsleeve Emporio Armani",
    "Bluzy i Longsleeve Joop!",
    "Bluzy i Longsleeve Joop! Jeans",
    "Bluzy i Longsleeve Patrizia Pepe",
    "Kurtki Płaszcze Katany i Kamizelki Aeronautica Militare",
    "Kurtki Płaszcze Katany i Kamizelki Armani Exchange",
    "Kurtki Płaszcze Katany i Kamizelki EA7",
    "Kurtki Płaszcze Katany i Kamizelki Elisabetta Franchi",
    "Kurtki Płaszcze Katany i Kamizelki Emporio Armani",
    "Kurtki Płaszcze Katany i Kamizelki Ice Play",
    "Kurtki Płaszcze Katany i Kamizelki John Richmond",
    "Kurtki Płaszcze Katany i Kamizelki Joop!",
    "Kurtki Płaszcze Katany i Kamizelki Joop! Collection",
    "Kurtki Płaszcze Katany i Kamizelki Joop! Jeans",
    "Kurtki Płaszcze Katany i Kamizelki Just Cavalli",
    "Kurtki Płaszcze Katany i Kamizelki Liu Jo",
    "Kurtki Płaszcze Katany i Kamizelki Liu Jo Sport",
    "Kurtki Płaszcze Katany i Kamizelki Max Mara Leisure",
    "Kurtki Płaszcze Katany i Kamizelki Patrizia Pepe",
    "Kurtki Płaszcze Katany i Kamizelki Pinko",
    "Kurtki Płaszcze Katany i Kamizelki Sportalm",
    "Kurtki Płaszcze Katany i Kamizelki Trussardi",
    "Kurtki Płaszcze Katany i Kamizelki Twinset",
    "Kurtki Płaszcze Katany i Kamizelki damskie Hetrego",
    "Kurtki i płaszcze John Richmond",
    "Swetry Kardigany i Golfy Ice Play",
    "Swetry Kardigany i Golfy Liu Jo",
    "Swetry Kardigany i Golfy Max Mara Leisure",
    "Swetry i Golfy Ice Play"
  ],
  "Handbag": [
    "Torebki",
    "Torebki Ice Play"
  ],
  "Skirt": [
    "Spódnice"
  ],
  "Shorts": [
    "Szorty i spodenki"
  ],
  "Necklace": [
    "Biżuteria"
  ],
  "Backpack": [],
  "Overall": [
    "Body",
    "Kombinezony",
    "Dresy",
    "Dresy Aeronautica Militare",
    "Dresy Emporio Armani",
    "Garnitury"
  ],
  "Belt": [
    "Paski"
  ],
  "Bag": [
    "Torby i plecaki"
  ],
  "Sunglasses": [
    "Okulary przeciwsłoneczne"
  ],
  "Luggage & bags": [
    "Torby i plecaki"
  ],
  "Hat": [
    "Nakrycia głowy"
  ],
  "Watch": [],
  "Bracelet": [
    "Biżuteria"
  ],
  "Scarf": [
    "Szale i chusty"
  ],
  "Top": [
    "Bluzki",
    "Bluzy",
    "Marynarki",
    "Marynarki i żakiety",
    "Polo",
    "T shirty",
    "Topy",
    "Swetry",
    "Koszule",
    "Kamizelki",
    "Garnitury",
    "Bluzy i Longsleeve Aeronautica Militare",
    "Bluzy i Longsleeve Armani Exchange",
    "Bluzy i Longsleeve Emporio Armani",
    "Bluzy i Longsleeve Joop!",
    "Bluzy i Longsleeve Joop! Jeans",
    "Bluzy i Longsleeve Patrizia Pepe",
    "Swetry Kardigany i Golfy Ice Play",
    "Swetry Kardigany i Golfy Liu Jo",
    "Swetry Kardigany i Golfy Max Mara Leisure",
    "Swetry i Golfy Ice Play"
  ],
  "Earrings": [],
  "blacklist": [
    "Marki",
    "nc",
    "Akcesoria",
    "Odzież",
    "Aeronautica Militare",
    "Armani Exchange",
    "Baldinini",
    "Balmain Paris Hair Couture",
    "EA7 Emporio Armani",
    "Elisabetta Franchi",
    "Emporio Armani",
    "John Richmond",
    "Joop!",
    "Joop! Collection",
    "Joop! Jeans",
    "Just Cavalli",
    "Liu Jo",
    "Liu Jo Sport",
    "Odzież damska",
    "Max Mara Leisure",
    "Pinko",
    "Hetrego",
    "Ice Play",
    "Patrizia Pepe",
    "Trussardi",
    "Twinset",
    "Sportalm",
    "Ręczniki",
    "Stroje Kąpielowe",
    "Kąpielówki",
    "Bielizna",
    "Akcesoria do włosów",
    "Kosmetyki do włosów",
    "Ozdoby do włosów dla kobiet"
  ]
}

const preparedProducts = getProductCategoriesByProductId(props.products)
// console.log('preparedProducts', preparedProducts)
// for (const preparedProduct of preparedProducts) {
//   console.log(preparedProduct)
//   // const {productCategory, product} = productArray
// //   console.log(product)
// //   // console.log('kategoria dla id: ' + product.id, findKeyByValue(categoriesMapping, productCategory))
// }
preparedProducts.forEach(productArray => {

  const {productCategory, product, productId} = productArray
  console.log('kategoria dla id: ' + productId, findKeyByValue(categoriesMapping, productCategory))

})


// console.log(findKeyByValue(categoriesMapping, 'Garnitury')); // Outputs: "Pants"

//
// const productImage = ref(generateStaticImage(props.product.image_link, 400, null))
// // const productImage = ref(props.product.image_link)
// const clickLink = ref(props.product.link_click)
// const formattedPrice = ref(formatPrice(props.product.price))
// const firstVariant = ref(props.product.variants[0])
// const salePrice = ref(formatPrice(firstVariant.value.sale_price))
//
// const actualPrice = salePrice.value ? salePrice.value : formattedPrice.value
// const oldPrice = salePrice.value ? formattedPrice.value : salePrice.value
//
// const priceNumber = parsePrice(actualPrice)
// const oldPriceNumber = parsePrice(oldPrice)
//
// const actualLink = ref(firstVariant.value.link)
//
// const handleClick = () => {
//   actualLink.value = clickLink.value
// };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "accesories hexagon small",
        style: _normalizeStyle({ backgroundImage: 'url('+'https://qon-csts3.quartic.com.pl/0f8ea68d4ec660fa/e1-c0/300xnull/aHR0cHM6Ly9zMy5ldS13ZXN0LTEuYW1h/em9uYXdzLmNvbS9xb24tY3N0czMucXVh/cnRpYy5jb20ucGwvMTBkNzYzMjhmNjA5/NWI4NS9haV9pbWcvNjRmMGNhOGIwOTE5/MS9iZXN0UHJvZHVjdFBob3Rvcy83MTA1/OS5qcGc=.webp'+')',
            backgroundSize: 'contain', backgroundPosition:'center', })
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "topwear hexagon big",
        style: _normalizeStyle({ backgroundImage: 'url('+_unref(images)[0]+')',
            backgroundSize: 'cover', backgroundPosition:'center', margin:'auto'})
      }, null, 4),
      _createElementVNode("div", {
        class: "legs hexagon big",
        style: _normalizeStyle({ backgroundImage: 'url('+_unref(images)[1]+')',
            backgroundSize: 'cover', backgroundPosition:'center', margin:'auto'})
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "hat hexagon small",
        style: _normalizeStyle({ backgroundImage: 'url('+'https://qon-csts3.quartic.com.pl/0f8ea68d4ec660fa/e1-c0/300xnull/aHR0cHM6Ly9zMy5ldS13ZXN0LTEuYW1h/em9uYXdzLmNvbS9xb24tY3N0czMucXVh/cnRpYy5jb20ucGwvMTBkNzYzMjhmNjA5/NWI4NS9haV9pbWcvNjRmMGNhOGIwOTE5/MS9iZXN0UHJvZHVjdFBob3Rvcy83MjEw/MS5qcGc=.webp'+')',
            backgroundSize: 'contain', backgroundPosition:'center', })
      }, null, 4),
      _createElementVNode("div", {
        class: "shoes hexagon small",
        style: _normalizeStyle({ backgroundImage: 'url('+_unref(images)[2]+')',
            backgroundSize: 'cover', backgroundPosition:'bottom center', })
      }, null, 4)
    ])
  ]))
}
}

})